<template>
  <img v-if="name === 'twitter'" class="x-and-tiktok-icon" src="@/client/assets/images/x-with-circle.svg" />
  <img v-else-if="name === 'tiktok'" class="x-and-tiktok-icon" src="@/client/assets/images/tiktok-with-circle.svg" />
  <i v-else :class="['mdi', `mdi-${name}`, `size-${size}`, `space-${space}`, `color-${color}`]" />
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

type TIconSize = 'small' | 'normal'
type TIconSpace = 'none' | 'left' | 'right' | 'both'
type TIconColor =
  | 'default'
  | 'white'
  | 'subtext'
  | 'disabled'
  | 'info'
  | 'primary'
  | 'link'
  | 'success'
  | 'danger'
  | 'warning'

export default defineComponent({
  props: {
    name: {
      type: String,
      default: ''
    },
    size: {
      type: String as PropType<TIconSize>,
      default: 'normal'
    },
    space: {
      type: String as PropType<TIconSpace>,
      default: 'none'
    },
    color: {
      type: String as PropType<TIconColor>,
      default: 'default'
    }
  }
})
</script>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.mdi {
  width: inherit;
  height: inherit;
}

.space-none {
  margin: 0;
}

.space-right {
  margin: 0 $spacing-unit 0 0;
}

.space-left {
  margin: 0 0 0 $spacing-unit;
}

.space-both {
  margin: 0 $spacing-unit;
}

.size-small {
  font-size: 16px;
}

.size-normal {
  font-size: 22px;
}

.x-and-tiktok-icon {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 16px;
  height: 16px;
  margin: 0;
  border-radius: 50%;
}

.color {
  &-white {
    color: $text-color-white;
  }

  &-subtext {
    color: $sub-text-color;
  }

  &-disabled {
    color: $disabled-color;
  }

  &-info {
    color: $info-color;
  }

  &-primary {
    color: $primary-color;
  }

  &-link {
    color: $link-color;
  }

  &-success {
    color: $success-color;
  }

  &-danger {
    color: $danger-color;
  }

  &-warning {
    color: $warning-color;
  }
}
</style>
